// Canvas celebrations with many randomized variants. Skipped when the user prefers reduced motion.
//   confetti({size:'small', origin:{x,y}})  one correct answer: a quick pop around `origin`
//   confetti({size:'big'})                  a passing round
//   confetti({size:'huge'})                 a perfect round / a new subset: bigger, plus a second effect
const COLORS = ['#2F4B9A', '#1F7A69', '#A86A12', '#B23F28', '#8EA6F2', '#E3B24C', '#52C3AA', '#EC7E63', '#C86FC9', '#F2C14E'];
const HISTORY = ['📜', '🏺', '⚔️', '🗺️', '👑', '🏛️', '⛵', '🔱', '📯', '🕰️', '🏺', '🛡️', '🪔', '🗿'];
const CHEER = ['⭐', '✨', '🎉', '👏', '🏆', '🌟', '💫', '🎊'];
const rnd = (a, b) => a + Math.random() * (b - a);
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
const TAU = Math.PI * 2;
const SIZE = 2, LIFE = 2;

const BIG = ['cannons', 'rain', 'fireworks', 'history', 'spiral', 'streamers', 'balloons', 'stars', 'coins', 'wave', 'fountain', 'sparkleStorm'];
const SMALL = ['pop', 'miniCannon', 'sparkle', 'emojiPop', 'ring', 'confettiPuff', 'risingStars', 'flick'];
let last = '';
const choose = (list) => { let k; do { k = pick(list); } while (k === last && list.length > 1); last = k; return k; };

function make(kind, W, H, k, o) {
  const out = [];
  const add = (o) => {
    const p = { x: 0, y: 0, vx: 0, vy: 0, g: 0.25, drag: 0.992, rot: rnd(0, TAU), vr: rnd(-0.2, 0.2), life: 0, max: 200, w: rnd(6, 11), h: rnd(8, 15), c: pick(COLORS), shape: 'rect', delay: 0, ...o };
    // everything is twice as big and lasts about twice as long; slower gravity keeps falling pieces up longer
    p.w *= SIZE; p.h *= SIZE; p.max = Math.round(p.max * LIFE); p.delay *= LIFE; p.g *= 0.55;
    if (p.g < 0.08) p.vy *= 0.6;
    out.push(p);
  };
  const ox = o ? o.x : W / 2, oy = o ? o.y : H * 0.4;
  const N = (n) => Math.max(4, Math.round(n * k));
  switch (kind) {
    // ---- big ----
    case 'cannons':
      for (const side of [0, 1]) for (let i = 0; i < N(70); i++) add({ x: side ? W + 4 : -4, y: H * 0.85, vx: (side ? -1 : 1) * rnd(5, 15), vy: -rnd(9, 22), shape: Math.random() < 0.2 ? 'circle' : 'rect' });
      break;
    case 'rain':
      for (let i = 0; i < N(130); i++) add({ x: rnd(0, W), y: rnd(-H * 0.8, -10), vy: rnd(1, 4), vx: rnd(-1, 1), g: 0.04, max: 400, drag: 1 });
      break;
    case 'fireworks':
      for (let b = 0; b < Math.max(2, 3 * k); b++) {
        const cx = rnd(W * 0.2, W * 0.8), cy = rnd(H * 0.15, H * 0.45), c = pick(COLORS), d = b * 22;
        for (let i = 0; i < 46; i++) { const a = (i / 46) * TAU, sp = rnd(3, 8); add({ x: cx, y: cy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, g: 0.09, drag: 0.965, c, w: 4, shape: 'circle', delay: d, max: 90 }); }
      }
      break;
    case 'history':
      for (let i = 0; i < N(34); i++) add({ x: rnd(0, W), y: rnd(-H * 0.6, -20), vy: rnd(1.5, 4), vx: rnd(-1.2, 1.2), g: 0.03, drag: 1, shape: 'emoji', ch: pick(HISTORY), w: rnd(22, 38), max: 420, vr: rnd(-0.05, 0.05) });
      break;
    case 'spiral':
      for (let i = 0; i < N(150); i++) { const a = i * 0.45, sp = 1.5 + i * 0.07; add({ x: W / 2, y: H * 0.4, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, g: 0.035, drag: 0.985, shape: 'circle', w: rnd(4, 8), delay: i * 0.6, max: 170 }); }
      break;
    case 'streamers': // long ribbons that flutter down
      for (let i = 0; i < N(60); i++) add({ x: rnd(0, W), y: rnd(-H * 0.5, -10), vy: rnd(1.5, 3.5), vx: rnd(-0.8, 0.8), g: 0.02, drag: 1, shape: 'ribbon', w: rnd(5, 8), h: rnd(40, 90), max: 420, vr: rnd(-0.03, 0.03), ph: rnd(0, TAU) });
      break;
    case 'balloons': // emoji balloons float up
      for (let i = 0; i < N(26); i++) add({ x: rnd(W * 0.05, W * 0.95), y: H + rnd(20, 300), vy: -rnd(2, 4.5), vx: rnd(-0.4, 0.4), g: 0, drag: 1, shape: 'emoji', ch: pick(['🎈', '🎈', '🎈', '🪁']), w: rnd(34, 54), max: 420, vr: 0, wob: rnd(0, TAU) });
      break;
    case 'stars': // twinkling stars drift down
      for (let i = 0; i < N(60); i++) add({ x: rnd(0, W), y: rnd(-H * 0.7, -10), vy: rnd(1, 3), vx: rnd(-0.6, 0.6), g: 0.02, drag: 1, shape: 'star', w: rnd(8, 16), max: 400, vr: rnd(-0.08, 0.08) });
      break;
    case 'coins': // a golden shower
      for (let i = 0; i < N(70); i++) add({ x: rnd(0, W), y: rnd(-H * 0.7, -10), vy: rnd(2, 5), vx: rnd(-0.8, 0.8), g: 0.08, drag: 0.999, shape: 'coin', c: pick(['#E3B24C', '#F2C14E', '#D9A441']), w: rnd(10, 16), max: 300 });
      break;
    case 'wave': // a sweeping curtain left to right
      for (let i = 0; i < N(140); i++) add({ x: -10 - rnd(0, 40), y: rnd(H * 0.05, H * 0.9), vx: rnd(6, 11), vy: rnd(-1.5, 1.5), g: 0.05, drag: 0.995, delay: (i / 140) * 40, max: 190 });
      break;
    case 'fountain': // up from the bottom centre
      for (let i = 0; i < N(120); i++) add({ x: W / 2 + rnd(-20, 20), y: H + 4, vx: rnd(-5, 5), vy: -rnd(14, 24), g: 0.3, delay: i * 0.4 });
      break;
    case 'sparkleStorm':
      for (let i = 0; i < N(80); i++) add({ x: rnd(0, W), y: rnd(H * 0.1, H * 0.8), vx: rnd(-0.5, 0.5), vy: rnd(-1, 0.3), g: 0, drag: 1, shape: 'star', w: rnd(6, 18), delay: rnd(0, 50), max: rnd(40, 90), vr: 0.06 });
      break;
    // ---- small (around the answer badge) ----
    case 'pop':
      for (let i = 0; i < N(34); i++) { const a = rnd(0, TAU), sp = rnd(2, 7); add({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 2, g: 0.2, drag: 0.95, w: rnd(4, 8), h: rnd(5, 10), max: 55 }); }
      break;
    case 'miniCannon':
      for (let i = 0; i < N(34); i++) add({ x: ox, y: oy, vx: rnd(-3, 3), vy: -rnd(5, 11), g: 0.28, drag: 0.97, w: rnd(4, 8), max: 70 });
      break;
    case 'sparkle':
      for (let i = 0; i < N(16); i++) add({ x: ox + rnd(-70, 70), y: oy + rnd(-40, 40), vx: 0, vy: -rnd(0.2, 0.9), g: 0, drag: 1, shape: 'star', w: rnd(8, 16), delay: rnd(0, 18), max: 50, vr: 0.1 });
      break;
    case 'emojiPop':
      for (let i = 0; i < N(7); i++) { const a = rnd(-Math.PI, 0), sp = rnd(3, 6); add({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, g: 0.16, drag: 0.97, shape: 'emoji', ch: pick(CHEER.concat(HISTORY)), w: rnd(20, 30), max: 65, vr: rnd(-0.1, 0.1) }); }
      break;
    case 'ring':
      for (let i = 0; i < N(28); i++) { const a = (i / N(28)) * TAU; add({ x: ox, y: oy, vx: Math.cos(a) * 5, vy: Math.sin(a) * 5, g: 0.02, drag: 0.93, shape: 'circle', w: 5, c: pick(COLORS.slice(0, 5)), max: 45 }); }
      break;
    case 'confettiPuff':
      for (let i = 0; i < N(26); i++) add({ x: ox + rnd(-30, 30), y: oy, vx: rnd(-2.5, 2.5), vy: -rnd(3, 8), g: 0.14, drag: 0.96, max: 75 });
      break;
    case 'risingStars':
      for (let i = 0; i < N(10); i++) add({ x: ox + rnd(-60, 60), y: oy + rnd(0, 20), vx: rnd(-0.4, 0.4), vy: -rnd(1.5, 3.2), g: -0.01, drag: 1, shape: 'emoji', ch: pick(['⭐', '🌟', '✨']), w: rnd(16, 26), delay: rnd(0, 14), max: 60 });
      break;
    case 'flick': // a quick diagonal spray from one side
      { const side = Math.random() < 0.5 ? -1 : 1; for (let i = 0; i < N(30); i++) add({ x: ox - side * 20, y: oy, vx: side * rnd(3, 9), vy: -rnd(2, 8), g: 0.25, drag: 0.96, max: 65 }); }
      break;
  }
  return out;
}

function draw(ctx, p) {
  const fade = Math.min(1, (p.max - p.life) / 25);
  ctx.save(); ctx.globalAlpha = Math.max(0, fade); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.c;
  switch (p.shape) {
    case 'circle': ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, TAU); ctx.fill(); break;
    case 'emoji': ctx.font = `${p.w}px serif`; ctx.textAlign = 'center'; ctx.fillText(p.ch, 0, 0); break;
    case 'star': { // four-point twinkle that pulses
      const s = p.w * (0.6 + 0.4 * Math.sin(p.life * 0.3)); ctx.beginPath();
      for (let i = 0; i < 8; i++) { const r = i % 2 ? s * 0.25 : s; const a = (i / 8) * TAU; ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r); }
      ctx.closePath(); ctx.fill(); break; }
    case 'coin': ctx.scale(Math.abs(Math.cos(p.life * 0.18)) + 0.15, 1); ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, TAU); ctx.fill(); break;
    case 'ribbon': { ctx.lineWidth = p.w; ctx.strokeStyle = p.c; ctx.lineCap = 'round'; ctx.beginPath();
      for (let t = 0; t <= 1.001; t += 0.1) ctx.lineTo(Math.sin(p.life * 0.12 + p.ph + t * 5) * p.w * 1.4, t * p.h);
      ctx.stroke(); break; }
    default: ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.life * 0.15)) + 1);
  }
  ctx.restore();
}

function run(kinds, k, origin) {
  const cv = document.createElement('canvas');
  cv.setAttribute('aria-hidden', 'true');
  cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:50';
  const dpr = Math.min(2, devicePixelRatio || 1), W = innerWidth, H = innerHeight;
  cv.width = W * dpr; cv.height = H * dpr;
  document.body.appendChild(cv);
  const ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
  const ps = kinds.flatMap((kind, i) => make(kind, W, H, k, origin).map((p) => ({ ...p, delay: p.delay + i * 35 })));
  let f = 0;
  (function tick() {
    ctx.clearRect(0, 0, W, H);
    let alive = 0;
    for (const p of ps) {
      if (p.delay > f) { alive++; continue; }
      p.life++; if (p.life > p.max || p.y > H + 80 || (p.y < -150 && p.vy < 0)) continue;
      alive++;
      p.vy += p.g; p.vx *= p.drag; p.vy *= p.drag; p.x += p.vx + (p.wob != null ? Math.sin(p.life * 0.06 + p.wob) * 0.8 : 0); p.y += p.vy; p.rot += p.vr;
      draw(ctx, p);
    }
    f++;
    if (alive) requestAnimationFrame(tick); else cv.remove();
  })();
}

export function confetti({ size = 'big', origin } = {}) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (size === 'small') return run([choose(SMALL)], 1, origin);
  if (size === 'huge') { const a = choose(BIG); let b; do { b = pick(BIG); } while (b === a); return run([a, b], 1.4); }
  run([choose(BIG)], 1);
}
